import Vue from "vue";

const requireComponents = require.context("./", true, /\.js$/);

requireComponents.keys().forEach((fileName) => {
  const install = requireComponents(fileName).default;
  const filterName = fileName.replace(/\.\/(\w*?)\.js/, "$1");
  if (typeof install === "function" && filterName) {
    Vue.filter(filterName, install);
  }
});
